import { isToolUIPart, lastAssistantMessageIsCompleteWithToolCalls, type UIMessage } from 'ai';

// An answered gate must resume even with unasked siblings: the server requests approvals sequentially.
export function lastAssistantMessageIsCompleteWithToolCallsOrApprovalResponses({
  messages,
  humanToolNames = new Set<string>(),
}: {
  messages: UIMessage[];
  humanToolNames?: ReadonlySet<string>;
}): boolean {
  if (lastAssistantMessageIsCompleteWithToolCalls({ messages })) return true;
  const message = messages.at(-1);
  if (message?.role !== 'assistant') return false;
  const tools = message.parts.filter(isToolUIPart);
  return (
    tools.some(part => part.state === 'approval-responded') &&
    !tools.some(
      part =>
        part.state === 'approval-requested' ||
        (part.state === 'input-available' &&
          humanToolNames.has(part.type === 'dynamic-tool' ? part.toolName : part.type.slice(5))),
    )
  );
}
